import { Info } from 'lucide-react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { AuthenticatedRoutes } from '@/router/routes';

interface NeedsReviewMemberAlertProps {
  className?: string;
}

/**
 * Banner on the details page of a synced member that may duplicate another one.
 * Only super admins can open such a member; they resolve it in Data reconciliation.
 */
export function NeedsReviewMemberAlert({ className }: NeedsReviewMemberAlertProps) {
  return (
    <Alert variant="info" className={className}>
      <Info className="h-5 w-5" />
      <AlertDescription>
        <Trans
          i18nKey="authenticated.team:details.needsReviewMessage"
          components={{
            reconciliationLink: (
              <Link
                to={AuthenticatedRoutes.DataReconciliation}
                className="font-medium text-primary underline underline-offset-4"
              />
            ),
          }}
        />
      </AlertDescription>
    </Alert>
  );
}
